import {Component} from 'react';

export default class Matrix extends Component {
}



// WEBPACK FOOTER //
// ./src/components/pricesCalendar/Matrix.js